module.exports = __webpack_public_path__ + "media/bootstrap-icons/puzzle-fill-f5470a93.svg";